import ng from 'angular';
import acpCore from 'core';
import { AcpTalkdeskChatbotPlugin } from './talkdesk-chatbot-plugin';
import { acpTalkdeskChatbotComponent } from './talkdesk-chatbot-component';
import './styles/${theme}/core.scss';

export const acpComponentTalkdeskChatbotDomain = ng
  .module('acp.component.talkdesk-chatbot-module', [acpCore.name])
  .component('talkdeskChatbot', acpTalkdeskChatbotComponent)
  .service('acpTalkdeskChatbotPlugin', AcpTalkdeskChatbotPlugin);

export { AcpTalkdeskChatbotPlugin };

export default acpComponentTalkdeskChatbotDomain;
